export const signOut = () =>
  fetch(`${process.env.NEXT_PUBLIC_API_URL}/sign_out`, {
    credentials: 'include',
    method: 'post',
  });
